module.exports = __webpack_public_path__ + "media/images/talent/case02-illust-76b0e3f44843f0f7812ffb2ebb8cbbc8.png";